import React, { useState } from "react";
import KeyBtn from "./Keyboard-key";
import EnterBtn from "./Keyboard-Enter";
import KeyboardOutput from "./Keyboard-Output";
import { useAppContext } from "../../context/appContext";

const KeyboardModal = () => {
    const { toggleModal, modal, editDesc, searchItems } = useAppContext();

    const [text, setText] = useState("");

    const addLetter = (stroke) => {
        setText(text + stroke);
    };

    const toggleModalHandler = (e) => {
        e.preventDefault();
        toggleModal();
        setText("");
    };

    const enterHandler = (e) => {
        e.preventDefault();
        if (modal.function == "search") {
            //Search
            searchItems(text);
        } else {
            editDesc(text);
        }
        setText("");
        toggleModal();
    };

    const deleteLetter = () => {
        setText(text.slice(0, -1));
    };

    return (
        <div className={"modal relative flex " + (modal.isOpen !== true ? "hidden" : "")}>
            <a
                className='text-white-100 absolute left-6 top-3 text-[68px]'
                href='#'
                onClick={toggleModalHandler}
            >
                X
            </a>
            <KeyboardOutput text={text} />
            <div className='wrapper relative max-w-fit '>
                <div className='my-2 flex gap-x-2'>
                    <KeyBtn onPress={addLetter} label='1' />
                    <KeyBtn onPress={addLetter} label='2' />
                    <KeyBtn onPress={addLetter} label='3' />
                    <KeyBtn onPress={addLetter} label='4' />
                    <KeyBtn onPress={addLetter} label='5' />
                    <KeyBtn onPress={addLetter} label='6' />
                    <KeyBtn onPress={addLetter} label='7' />
                    <KeyBtn onPress={addLetter} label='8' />
                    <KeyBtn onPress={addLetter} label='9' />
                    <KeyBtn onPress={addLetter} label='0' />
                    <KeyBtn onPress={deleteLetter} label='BACKSPACE' />
                </div>
                <div className='my-2 flex gap-x-2'>
                    <KeyBtn onPress={addLetter} label='q' />
                    <KeyBtn onPress={addLetter} label='w' />
                    <KeyBtn onPress={addLetter} label='e' />
                    <KeyBtn onPress={addLetter} label='r' />
                    <KeyBtn onPress={addLetter} label='t' />
                    <KeyBtn onPress={addLetter} label='y' />
                    <KeyBtn onPress={addLetter} label='u' />
                    <KeyBtn onPress={addLetter} label='i' />
                    <KeyBtn onPress={addLetter} label='o' />
                    <KeyBtn onPress={addLetter} label='p' />
                </div>
                <div className='my-2 flex gap-x-2'>
                    <KeyBtn onPress={addLetter} label='a' />
                    <KeyBtn onPress={addLetter} label='s' />
                    <KeyBtn onPress={addLetter} label='d' />
                    <KeyBtn onPress={addLetter} label='f' />
                    <KeyBtn onPress={addLetter} label='g' />
                    <KeyBtn onPress={addLetter} label='h' />
                    <KeyBtn onPress={addLetter} label='j' />
                    <KeyBtn onPress={addLetter} label='k' />
                    <KeyBtn onPress={addLetter} label='l' />
                </div>
                <div className='absolute right-1 top-1/2 flex gap-x-2'>
                    <EnterBtn onSubmit={enterHandler} label='ENTER' />
                </div>
                <div className='my-2 flex gap-x-2'>
                    <KeyBtn label='SHIFT' />
                    <KeyBtn onPress={addLetter} label='z' />
                    <KeyBtn onPress={addLetter} label='x' />
                    <KeyBtn onPress={addLetter} label='c' />
                    <KeyBtn onPress={addLetter} label='SPACE' />
                    <KeyBtn onPress={addLetter} label='v' />
                    <KeyBtn onPress={addLetter} label='b' />
                    <KeyBtn onPress={addLetter} label='n' />
                    <KeyBtn onPress={addLetter} label='m' />
                </div>
            </div>
        </div>
    );
};

export default KeyboardModal;
